<div class="status-tag" [ngClass]="statusText">
  {{ statusText }}
</div>
